export default __webpack_public_path__ + "static/media/icon-maternity-leave.110e1140.svg";